import { render, staticRenderFns } from "./Incorporation.vue?vue&type=template&id=16e92e5e&scoped=true"
import script from "./Incorporation.vue?vue&type=script&lang=js"
export * from "./Incorporation.vue?vue&type=script&lang=js"
import style0 from "./Incorporation.vue?vue&type=style&index=0&id=16e92e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e92e5e",
  null
  
)

export default component.exports